import { Component, Input, Output   } from '@angular/core'; 
import { NgxPaginationModule } from 'ngx-pagination'; 
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { DebtService } from '../_Services/debt.service';
import { CommonService } from '../_Services/common.service';

import { Router, ActivatedRoute } from '@angular/router';  

@Component({
  templateUrl: 'debts.component.html'
})
export class DebtsComponent {

    model: any = {}; 

    debts = [];   
    p: any = 1;  
    paginator = [];
	constructor(private debtService: DebtService, private route:ActivatedRoute) { }

    changeShape(shape){
        console.log(shape);
        this.model.product = shape;
    } 
 	
 	pageChanged(page: Number) {
        if(page == undefined) {
            page = 1;
        }
		this.p = page; 
		var debt_imported_id = this.route.snapshot.params['id'];  
		this.debtService.getDebts(debt_imported_id, page, this.model).subscribe(result => { 
                this.debts = result.data;
                this.paginator = result.paginator; 
            });  
	}  

	ngOnInit() { 
		var debt_imported_id = this.route.snapshot.params['id'];
		this.debtService.getDebts(debt_imported_id, this.p, null).subscribe(result => {
                console.log(result);
                this.debts = result.data;
                this.paginator = result.paginator; 
            });  
        this.model.product = '';
	}
}


// WEBPACK FOOTER //
// ./src/app/debts/debts.component.ts